<template>
  <div>
    <!-- <validation-observer ref="playerValidation"> -->

    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showNewArbitro"
      scrollable
      no-close-on-backdrop
      title="Agregar / Editar Arbitro"
      @hidden="resetModal"
      cancel-variant="outline-secondary"
    >
      <b-row>
        <b-col cols="12" md="4">
          <croppa
            v-model="croppaFoto"
            :width="170"
            :height="200"
            placeholder="Subir foto arbitro"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="disabledObj.foto"
            remove-button-color="black"
            :show-loading="false"
            :loading-size="50"
            loading-color="#606060"
            :quality="1"
            :initial-image="arbitroSelected.foto_jug"
          ></croppa>
        </b-col>
        <b-col cols="12" md="5" class="ml-1">
          <croppa
            v-model="croppaCedula"
            :width="290"
            :height="200"
            placeholder="Subir frontal cedula"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="true"
            remove-button-color="black"
            :show-loading="true"
            :loading-size="50"
            loading-color="#606060"
            :initial-image="arbitroSelected.foto_cedula"
          ></croppa>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col md="12">
          <v-select
            ref="refCi"
            id="input-ci-pasaporte-arb"
            :options="listPlayers"
            placeholder="C.I / PASAPORTE *"
            outlined
            taggable
            v-model="arbitroSelected.ci_pasaporte"
            @search="searchPlayer"
            @input="changePlayer"
            :disabled="disabledObj.buscador"
            :clearable="
              $store.state.someVariables.actionPlayer == UPDATE_DATA_PLAYER
                ? false
                : true
            "
          ></v-select>
        </b-col>
        <b-col md="12" style="margin-top:20px">
          <div class="form-label-group">
            <b-form-input
              id="floating-nombres-arb"
              placeholder="Ingrese Nombres *"
              :formatter="formatter"
              v-model="arbitroSelected.nombre"
              :disabled="disabledObj.nombres"
            />
            <label for="floating-nombres">Nombres</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:8px">
          <div class="form-label-group">
            <b-form-input
              id="floating-nacimiento-arb"
              type="date"
              v-model="arbitroSelected.fecha_nac"
              :disabled="disabledObj.fechaNacimiento"
              @input="calculateAge"
            />
            <label for="floating-nacimiento">Fecha de nacimiento *</label>
          </div>
        </b-col>

        <b-col md="12" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="floating-edad"
              placeholder="Edad"
              v-model="arbitroSelected.edad"
              disabled
            />
            <label for="floating-edad">Edad</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:10px">
          <div class="form-label-group">
            <b-form-input
              id="floating-email"
              placeholder="Ingrese Email (Opc)"
              v-model="arbitroSelected.email"
              :disabled="disabledObj.email"
            />
            <label for="floating-email">Email (Opc)</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="floating-direccion"
              placeholder="Ingrese Dirección (Opc)"
              v-model="arbitroSelected.direccion"
              :disabled="disabledObj.direccion"
            />
            <label for="floating-direccion">Direccion (Opc)</label>
          </div>
        </b-col>
        <b-col md="12" style="margin-top:6px">
          <div class="form-label-group">
            <b-form-input
              id="floating-telefono"
              placeholder="Ingrese telefono (Opc)"
              v-model="arbitroSelected.telefono"
              :disabled="disabledObj.telefono"
            />
            <label for="floating-telefono">Teléfono (Opc)</label>
          </div>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <b-button
              v-if="
                USER().rol === `${ROLES.ADMIN}` ||
                  USER().rol === `${ROLES.SUPER}` ||
                  USER().rol === `${ROLES.CALIFICACION}` ||
                  (USER().rol === `${ROLES.CLUB}` &&
                    categoriaSeleccionada.isOpen &&
                    !categoriaSeleccionada.isInReview &&
                    (arbitroSelected.estado_jug ==
                      `${ESTADO_JUGADOR.INSCRITO}` ||
                      arbitroSelected.estado_jug ==
                        `${ESTADO_JUGADOR.REVISADO}`))
              "
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              @click="savePlayer"
            >
              <span>{{ actionPlayer }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="float-right mr-1"
              @click="onlyClose"
            >
              Cancelar
            </b-button>
          </template>
          <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
          </div>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
      <!-- <b-button ref="hola" @click="holaMundo">
        aplasta
      </b-button> -->
    </b-modal>
    <!-- </validation-observer> -->
  </div>
</template>
<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import { required, email } from '@validations'
import vSelect from 'vue-select'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  // watch,
  // watchEffect,
  computed,
  // reactive,
  ref,
  // onUpdated,
} from '@vue/composition-api'

// import Cleave from 'vue-cleave-component'
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  // BFormTextarea,
  // BFormGroup,
  // BFormRadioGroup,
  // BInputGroupPrepend,
  // BInputGroup,
  // BFormCheckbox,
  BAlert,
  BButton,
  BSpinner,
  // VBPopover,
  // BAvatar,
  // BPopover,
  // BFormTags,
  // VBTooltip,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'
import apiCall from '../../utils/apiCall'

import {
  URL,
  USER,
  ROLES,
  ESTADO_JUGADOR,
  INSERT_DATA_PLAYER,
  INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
} from '../../utils/variables'

const moment = require('moment-timezone')

moment.tz.setDefault('America/Guayaquil')

export default {
  components: {
    BModal,
    BRow,
    BCol,
    // vSelect,
    BFormInput,
    // BFormTextarea,
    vSelect,
    // ValidationProvider,
    // ValidationObserver,
    // Cleave,
    // BFormGroup,
    // BFormRadioGroup,
    // BInputGroupPrepend,
    // BInputGroup,
    // BFormCheckbox,
    BAlert,
    BButton,
    BSpinner,
    // BAvatar,
    // BPopover,
    // BFormTags,
    // BForm,
    // BInputGroup,
    // BInputGroupPrepend,
  },
  directives: {
    // 'b-popover': VBPopover,
    // 'b-tooltip': VBTooltip,
    heightFade,
    Ripple,
  },
  props: {
    arbitroSelected: Object,
    arbitroAuxiliar: Object,
    categoriaSeleccionada: Object,
    posiciones: Array,
    listCategorias: Array,
  },
  setup(props, { emit }) {
    // console.log('setup modal')
    // console.log(props.isAbierto)
    const croppaFoto = ref({})
    const userEmail = ref('')
    const croppaCedula = ref({})
    const listPlayers = ref([])
    const filtered = ref([])
    const listEquiposTransferir = ref([])
    const { getApi, postApi } = apiCall()
    const selectedRadio = ref('active')
    const disabledInputs = ref(false)
    // eslint-disable-next-line
    const disabledObservacion = ref(USER().rol === ROLES.CLUB ? true : false)
    const isPassportOther = ref(false)
    const hasError = ref(false)
    const showLoading = ref(false)
    const messageError = ref('')
    const variante = ref('danger')
    const refCi = ref()
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const popoverShow = ref(true)
    // const observ = ref(['la fotografia ha sido actualizada', 'dso'])
    const optionsEstadoJugador = ref([
      {
        text: 'Inscrito',
        value: 'inscrito',
        disabled: false,
        selected: true,
      },
      { text: 'Revisado', value: 'revisado', disabled: false },
      { text: 'Calificado', value: 'calificado', disabled: false },
    ])
    // const observaciones = computed(() => {
    //   const arrayReturn = []
    //   if (props.arbitroSelected.observaciones !== undefined) {
    //     props.arbitroSelected.observaciones.forEach(element => {
    //       arrayReturn.push(element.mensaje)
    //     })
    //   }
    //   return arrayReturn
    // })
    const actionPlayer = computed(() => {
      let texto = 'Guardar'
      if (
        store.getters['someVariables/getActionArbitro'] === INSERT_DATA_PLAYER
      ) {
        texto = 'Guardar'
      } else if (
        store.getters['someVariables/getActionArbitro'] ===
        INSERT_DATA_HISTORY_PLAYER
      ) {
        texto = 'Agregar'
      } else if (
        store.getters['someVariables/getActionArbitro'] === UPDATE_DATA_PLAYER
      ) {
        texto = 'Actualizar'
      }
      return texto
    })
    const disabledObj = computed(() => {
      const objDisabled = {
        buscador: false,
        nombres: false,
        apellidos: false,
        fechaNacimiento: false,
        direccion: false,
        telefono: false,
        email: false,
        foto: true,
      }
      const action = store.getters['someVariables/getActionArbitro']
      if (action === INSERT_DATA_PLAYER) {
        objDisabled.buscador = false
        objDisabled.nombres = false
        objDisabled.apellidos = false
        objDisabled.fechaNacimiento = false
      } else if (action === INSERT_DATA_HISTORY_PLAYER) {
        objDisabled.nombres = true
        objDisabled.apellidos = true
        objDisabled.fechaNacimiento = true
      } else if (action === UPDATE_DATA_PLAYER) {
        if (props.arbitroSelected.nuevo === 'n') {
          objDisabled.buscador = true
          objDisabled.nombres = true
          objDisabled.apellidos = true
          objDisabled.fechaNacimiento = true
          objDisabled.foto = false
        }
        if (
          USER().editar_player &&
          (USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.CALIFICACION)
        ) {
          objDisabled.buscador = false
          objDisabled.nombres = false
          objDisabled.apellidos = false
          objDisabled.fechaNacimiento = false
          objDisabled.foto = true
        }
        if (
          props.arbitroSelected.permiso_editar_personal &&
          USER().rol === ROLES.CLUB
        ) {
          objDisabled.buscador = true
          objDisabled.nombres = false
          objDisabled.apellidos = false
          objDisabled.fechaNacimiento = false
          objDisabled.foto = true
        }
      }
      // console.log('aqui')
      // console.log(action, props.arbitroSelected.nuevo)
      // if (props.arbitroSelected.nuevo === 'n') {
      //   objDisabled.buscador = true
      //   objDisabled.nombres = true
      //   objDisabled.apellidos = true
      //   objDisabled.fechaNacimiento = true
      // }
      // let disabled = false
      // if (props.arbitroSelected.nuevo === 'n') {
      //   disabled = true
      // }
      // console.log(disabled)
      return objDisabled
    })
    const optionsEstado = computed(() => {
      if (USER().rol === ROLES.CLUB) {
        if (props.arbitroSelected.estado_jug === ESTADO_JUGADOR.INSCRITO) {
          optionsEstadoJugador.value[0].selected = true
          optionsEstadoJugador.value[0].disabled = false
          optionsEstadoJugador.value[1].disabled = true
          optionsEstadoJugador.value[2].disabled = true
        } else if (
          props.arbitroSelected.estado_jug === ESTADO_JUGADOR.REVISADO
        ) {
          optionsEstadoJugador.value[1].selected = true
          optionsEstadoJugador.value[1].disabled = false
          optionsEstadoJugador.value[0].disabled = true
          optionsEstadoJugador.value[2].disabled = true
        } else if (
          props.arbitroSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO
        ) {
          optionsEstadoJugador.value[2].selected = true
          optionsEstadoJugador.value[2].disabled = false
          optionsEstadoJugador.value[0].disabled = true
          optionsEstadoJugador.value[1].disabled = true
        }
      }
      if (
        USER().rol === ROLES.SUPER ||
        USER().rol === ROLES.ADMIN ||
        USER().rol === ROLES.CALIFICACION
      ) {
        if (props.arbitroSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO) {
          props.arbitroSelected.permiso_editar_personal = false
        }
      }
      // else if (
      //   USER().rol === ROLES.ADMIN ||
      //   USER().rol === ROLES.SUPER ||
      //   USER().rol === ROLES.CALIFICACION
      // ) {
      //   if (props.arbitroSelected.estado_jug === ESTADO_JUGADOR.CALIFICADO) {
      //     // observacionesAuxiliar = props.arbitroSelected.observaciones
      //     props.arbitroSelected.observaciones = []
      //   }
      // }
      return optionsEstadoJugador.value
    })

    // watchEffect(() => croppaFoto.value.refresh())
    // watch(fotoHistorial, (despues, antes) => {
    //   console.log(`watchRefAnt: ${antes}`)
    //   props.arbitroSelected.foto_jug = despues
    //   console.log(`watchRefDes: ${despues}`)
    //   croppaFoto.value.refresh()
    // })
    // const showNewPlayer = ref(true)
    // onUpdated(() => {
    //   // console.log(`updated() val: `)
    //   this.croppaFoto.value.refresh()
    // })

    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function formatter(value) {
      return value.toUpperCase()
    }
    function setCroppaRefresh() {
      setTimeout(() => {
        croppaFoto.value.refresh()
        croppaCedula.value.refresh()
      }, 100)
    }

    function initPlayer() {
      props.arbitroSelected.nombre = ''
      props.arbitroSelected.fecha_nac = ''
      props.arbitroSelected.direccion = ''
      props.arbitroSelected.telefono = ''
      props.arbitroSelected.email = ''
      props.arbitroSelected.foto_jug = ''
      props.arbitroSelected.foto_cedula = ''
      props.arbitroSelected.id_arbitro = null
      props.arbitroSelected.edad = 0
      disabledInputs.value = false
      store.commit('someVariables/UPDATE_ACTION_ARBITRO', INSERT_DATA_PLAYER)
      setCroppaRefresh()
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', props.arbitroSelected.id_gremio_arbitral)
      hasError.value = false
      listPlayers.value = []
      showLoading.value = false
      countDownChanged(0)
      // initPlayer()
      //       this.$emit('closeModal', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_ARBITRO', false)
      showLoading.value = false
    }

    function calculateAge(date) {
      // const years = moment().diff(date, 'YYYY-MM-DD')
      const diffDuration = moment.duration(moment().diff(date))
      props.arbitroSelected.edad = `${diffDuration.years()} años, ${diffDuration.months()} meses, ${diffDuration.days()} dias`
    }
    // const showNewPlayer = computed(() => props.isOpen)
    async function searchPlayer(value) {
      // console.log(value)
      // console.log(props.arbitroSelected)
      const action = store.getters['someVariables/getActionArbitro']
      if (action === INSERT_DATA_PLAYER) {
        if (value.length) {
          const path = `ApiArbitros/getArbitrosCedula/${value}`
          const data = await getApi(URL, path)
          // this.listPlayers.value = data.jugadores
          if (data.flag === 'si') {
            listPlayers.value = []
            data.data.forEach(element => {
              const obj = {
                label: `${element.ci_pasaporte}`,
                value: element.id_arbitro,
                nombre: element.nombre,
                direccion: element.direccion,
                email: element.email,
                telefono: element.telefono,
                fecha_nac: element.fecha_nac,
                edad: element.edad,
                foto_jug: element.foto_jug,
                foto_cedula: element.foto_cedula,
                id_arbitro: element.id_arbitro || null,
                id_gremio_arbitral: props.arbitroSelected.id_gremio_arbitral,
              }
              listPlayers.value.push(obj)
            })
          } else {
            // props.arbitroSelected.ci_pasaporte = value
            initPlayer()
          }
        } else {
          // this.listCI = []
          // this.deHistorial=false;
          // console.log("ssss");
        }
      }
      //  trigger a mutation, or dispatch an action
    }
    function desabilitarEnHistorial(obj) {
      obj.nombres = true
      obj.direccion = true
      obj.telefono = true
      obj.email = true
      obj.fechaNacimiento = true
    }

    function setearDatosDeHistorial(item) {
      props.arbitroSelected.id_arbitro = item.id_arbitro
      props.arbitroSelected.nombre = item.nombre
      props.arbitroSelected.email = item.email
      props.arbitroSelected.fecha_nac = item.fecha_nac
      props.arbitroSelected.telefono = item.telefono
      props.arbitroSelected.direccion = item.direccion
      props.arbitroSelected.rol = USER().rol
      props.arbitroSelected.foto_jug = item.foto_jug
      props.arbitroSelected.foto_cedula = item.foto_cedula
      props.arbitroSelected.edad = item.edad
      disabledInputs.value = true
      desabilitarEnHistorial(disabledObj.value)
      setCroppaRefresh()
    }
    function changePlayer(item) {
      let action = store.getters['someVariables/getActionArbitro']
      if (item !== null) {
        if (action !== UPDATE_DATA_PLAYER) {
          if (item.id_arbitro === undefined) {
            // console.log('accion insertar jugador')
            action = INSERT_DATA_PLAYER
          } else {
            // console.log('accion insertar jugador de historial')
            action = INSERT_DATA_HISTORY_PLAYER
            setearDatosDeHistorial(item)
          }
        }
        store.commit(
          'someVariables/UPDATE_ACTION_ARBITRO',
          // eslint-disable-next-line
          action
        )
        // console.log(action)
      } else {
        initPlayer()
      }
    }
    function focusInput(id, error) {
      document.getElementById(id).focus()
      messageError.value = error
    }
    function hasErrorForm() {
      let error = false
      if (
        props.arbitroSelected.ci_pasaporte === '' ||
        props.arbitroSelected.ci_pasaporte === null ||
        props.arbitroSelected.ci_pasaporte === undefined
      ) {
        focusInput('input-ci-pasaporte-arb', 'C.I o Passaporte es requerido')
        error = true
      } else if (
        props.arbitroSelected.nombre === '' ||
        props.arbitroSelected.nombre === null ||
        props.arbitroSelected.nombre === undefined
      ) {
        focusInput('floating-nombres-arb', 'Nombres es requerido')
        error = true
      } else if (
        props.arbitroSelected.fecha_nac === '' ||
        props.arbitroSelected.fecha_nac === null ||
        props.arbitroSelected.fecha_nac === undefined
      ) {
        focusInput(
          'floating-nacimiento-arb',
          // eslint-disable-next-line
          'Fecha de nacimiento es requerido'
        )
        error = true
      } else {
        error = false
      }
      return error
    }
    function getPicturePlayer(croppa) {
      let fotografia = ''
      if (croppa.value.chosenFile == null) {
        fotografia = ''
      } else {
        const fotografiaBase64 = croppa.value.generateDataUrl(
          'image/jpeg',
          // eslint-disable-next-line
          0.5
        )
        fotografia = fotografiaBase64
      }
      return fotografia
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }

    // function transformarObservacionesToString(observaciones) {
    //   let strinConversion = ''
    //   observaciones.forEach(element => {
    //     if (
    //       element !== 'La fotografía ha sido actualizada' &&
    //       element !== 'La cédula ha sido actualizada'
    //     ) {
    //       strinConversion += `${element};`
    //     }
    //   })
    //   return strinConversion
    // }
    function getStringChanges() {
      // let has = false
      let stringFinal = ''
      if (
        props.arbitroAuxiliar.ci_pasaporte !==
        props.arbitroSelected.ci_pasaporte
      ) {
        stringFinal += `cambia cedula de ${props.arbitroAuxiliar.ci_pasaporte} a ${props.arbitroSelected.ci_pasaporte} `
      }
      if (props.arbitroAuxiliar.nombre !== props.arbitroSelected.nombre) {
        stringFinal += `cambia nombres de ${props.arbitroAuxiliar.nombre} a ${props.arbitroSelected.nombre} `
      }
      if (props.arbitroAuxiliar.fecha_nac !== props.arbitroSelected.fecha_nac) {
        stringFinal += `cambia fecha nacimiento de ${props.arbitroAuxiliar.fecha_nac} a ${props.arbitroSelected.fecha_nac} `
      }
      if (props.arbitroSelected.fotografia !== '') {
        stringFinal += 'cambia fotografía '
      }
      if (props.arbitroSelected.fotografia_cedula !== '') {
        stringFinal += 'cambia fotografía cedula'
      }
      return stringFinal
    }

    async function savePlayer() {
      const action = store.getters['someVariables/getActionArbitro']
      hasError.value = hasErrorForm()
      if (!hasError.value) {
        showLoading.value = true
        if (action === INSERT_DATA_PLAYER) {
          const isObject =
            typeof props.arbitroSelected.ci_pasaporte === 'object'
          // console.log(isObject)
          if (isObject) {
            props.arbitroSelected.ci_pasaporte_env =
              props.arbitroSelected.ci_pasaporte.label
          } else {
            props.arbitroSelected.ci_pasaporte_env =
              props.arbitroSelected.ci_pasaporte
          }
          props.arbitroSelected.fotografia = getPicturePlayer(croppaFoto)
          props.arbitroSelected.fotografia_cedula = getPicturePlayer(
            // eslint-disable-next-line
            croppaCedula
          )
          // props.arbitroSelected.observaciones_enviar = transformarObservacionesToString(
          //   // eslint-disable-next-line
          //   props.arbitroSelected.observaciones
          // )
          props.arbitroSelected.rol = USER().rol
          // console.log(props.arbitroSelected)
          // throw 'error'
          // this.openLoadingContained("#" + this.idButtonLogin);
          const path = 'ApiArbitros/insertArbitro'
          props.arbitroSelected.idUserIngresa = USER().id_usuario
          const response = await postApi(URL, path, props.arbitroSelected)
          if (response.flag === 'si') {
            showMessageAlert('success', 'ARBITRO agregado exitosamente')
            emit('recargarHistorial', props.arbitroSelected.id_gremio_arbitral)
            initPlayer()
            props.arbitroSelected.ci_pasaporte = null
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        } else if (action === INSERT_DATA_HISTORY_PLAYER) {
          // console.log(props.arbitroSelected)
          // props.arbitroSelected.rol = USER().rol
          props.arbitroSelected.idArbitro = props.arbitroSelected.id_arbitro
          const path = 'ApiArbitros/desactivateArbitro/a'
          const response = await postApi(URL, path, props.arbitroSelected)
          if (response.flag === 'si') {
            emit('recargarHistorial', props.arbitroSelected.id_gremio_arbitral)
            showMessageAlert('success', 'ARBITRO activado exitosamente')
            initPlayer()
            props.arbitroSelected.ci_pasaporte = null
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        } else if (action === UPDATE_DATA_PLAYER) {
          props.arbitroSelected.fotografia = getPicturePlayer(croppaFoto)
          props.arbitroSelected.fotografia_cedula = getPicturePlayer(
            // eslint-disable-next-line
            croppaCedula
          )
          props.arbitroSelected.rol = USER().rol

          const infoInicial = `Arbitros C.I: ${props.arbitroSelected.ci_pasaporte}`
          const dataMovimientoString = getStringChanges()
          const tieneCambios = dataMovimientoString === '' ? 'no' : 'si'
          props.arbitroSelected.hasChanges = tieneCambios
          props.arbitroSelected.dataMovimiento = `${infoInicial} ${dataMovimientoString}`

          // props.arbitroSelected.idTorneo =
          //   store.getters['someVariables/getTorneoSeleccionado'].id_torneo
          const path = 'ApiArbitros/actualizarArbitro'
          props.arbitroSelected.idUserIngresa = USER().id_usuario
          // props.arbitroSelected.editar_player = USER().editar_player
          const response = await postApi(URL, path, props.arbitroSelected)
          if (response.flag === 'si') {
            emit('recargar', props.arbitroSelected.id_gremio_arbitral)
            initPlayer()
            store.commit('someVariables/UPDATE_SHOW_NEW_ARBITRO', false)
          } else {
            showMessageAlert('danger', response.mensaje)
          }
          showLoading.value = false
        }
      } else {
        variante.value = 'danger'
        dismissCountDown.value = dismissSecs.value
      }
      // console.log(hasError.value)
      // console.log()
    }

    return {
      userEmail,
      croppaFoto,
      croppaCedula,
      listPlayers,
      searchPlayer,
      filtered,
      changePlayer,
      initPlayer,
      selectedRadio,
      optionsEstadoJugador,
      disabledInputs,
      isPassportOther,
      savePlayer,
      hasErrorForm,
      hasError,
      messageError,
      refCi,
      showLoading,
      variante,
      resetModal,
      countDownChanged,
      dismissCountDown,
      dismissSecs,
      formatter,
      popoverShow,
      calculateAge,
      // defineIsClasificado,
      ROLES,
      USER,
      ESTADO_JUGADOR,
      optionsEstado,
      disabledObservacion,
      onlyClose,
      disabledObj,
      UPDATE_DATA_PLAYER,
      listEquiposTransferir,
      actionPlayer,
      // observ,
      // observaciones,
      // holaMundo,
      // hola,
      // fotoHistorial,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
